import { render, staticRenderFns } from "./IconBook.vue?vue&type=template&id=48c4221a"
import script from "./IconBook.vue?vue&type=script&lang=js"
export * from "./IconBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports